<template>
  <div class="membership-benefits-list-item">
    <img
      v-if="iconUrl"
      :src="iconUrl"
      alt="Go Pro Icon"
      class="membership-benefits-list-item__icon"
    />
    <img
      v-else
      src="@/assets/images/icons/check/check-in-circle_white-with-purple-bg.svg"
      alt="Go Pro Check Icon"
      class="membership-benefits-list-item__icon"
    />
    <p class="membership-benefits-list-item__text">{{ text }}</p>
  </div>
</template>

<script>
export default {
  props: {
    iconUrl: {
      type: String,
    },
    text: {
      type: String,
      require: true,
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
@import "@/assets/style/_variables.scss";

.membership-benefits-list-item {
  display: flex;
  gap: 1.6rem;
}

.membership-benefits-list-item__icon {
  width: 2rem;
  height: 2rem;

  @include min-tablet {
    width: 2.4rem;
    height: 2.4rem;
  }
}

.membership-benefits-list-item__text {
  color: $text-color-primary;
  font-size: 1.6rem;
  font-weight: 400;
  text-align: left;

  @include min-tablet {
    font-size: 2rem;
  }

  &:first-letter {
    text-transform: uppercase;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/store/subscription/benefits-panel/MembershipBenefitsListItem.vue